import { logger } from '../util/logger';
import { get, parseData, post } from './common';
export const defaultHandler = (resp) => resp
    .json()
    .then((json) => JSON.parse(json.d.Data))
    .catch(logger.error);
export const responseHandler = (resp) => {
    if (resp.Status === 'error' || resp.Status === 'reject') {
        throw new Error(resp.Message);
    }
    return JSON.parse(resp.Data);
};
export const returnFullResponseHandler = (resp) => {
    if (resp.Status === 'error') {
        throw new Error(resp.Message);
    }
    return { ...resp, ...{ Data: JSON.parse(resp.Data) } };
};
export const webApiResponseHandler = (resp) => {
    if (!resp.ok) {
        throw new Error(resp.statusText);
    }
    return resp;
};
export const webApiResponseHandlerJSON = (resp) => {
    if (!resp.ok) {
        throw new Error(resp.statusText);
    }
    return resp.json();
};
/**
 *
 * @param {*} cacheKey change cache key to bust GetAccountConfig cache
 * @returns Promise
 */
export const getAccountConfig = () => post('/InternalAPI/ApplicationAPI.asmx/GetAccountConfig', {
    CacheKey: new Date().getTime()
}).then(async (resp) => {
    const data = await resp.json();
    return data.d;
});
export const getExpTypes = () => 
// to do: useExpCats needs to pass in a way to distinguish we are dealing with a SR, setting to true for now
post('/InternalAPI/ApplicationAPI.asmx/GetExpTypes').then(defaultHandler);
export const getExpenseCategories = (options, excludeSRExpCats = true) => 
// to do: useExpCats needs to pass in a way to distinguish we are dealing with a SR, setting to true for now
post('/InternalAPI/ExpenseCategoryAPI.asmx/GetExpCats', {
    Dept: options.Dept || null,
    ExpType: options.ExpType || null,
    ExcludeSRExpCats: excludeSRExpCats,
    EmpIdOverride: options.Emp?.PK || null
}).then(defaultHandler);
export const getExpRptUDFRecentSelections = (index, options) => post('/InternalAPI/UDFAPI.asmx/GetExpRptUDFRecentSelections', {
    Index: index,
    ...options
}).then(defaultHandler);
export const getTextUDFRecentSelections = (index, options) => post('/InternalAPI/UDFAPI.asmx/GetTextUDFRecentSelections', {
    Index: index,
    ...options
}).then(defaultHandler);
export const getExpRptUDFs = (udfIndex, options = {}) => post('/InternalAPI/UDFAPI.asmx/GetExpRptUDFs', {
    Index: udfIndex,
    Emp: options.Emp || {}
}).then(defaultHandler);
export const getExpRptUDFsByKeyword = (udfIndex, keyword, options = {}) => post('/InternalAPI/UDFAPI.asmx/GetExpRptUDFsByKeyword', {
    Index: udfIndex,
    strKeyWord: keyword,
    Emp: options.Emp || {},
    DynamicFilterPK: options.DynamicFilterPK || {}
}).then(defaultHandler);
export const getEmpUDFsByKeyword = (strKeyWord, Index) => post('/InternalAPI/UDFAPI.asmx/GetEmpUDFsByKeyword', {
    strKeyWord,
    Index
}).then(defaultHandler);
export const getCurrencies = () => 
// keyword parameter for textbox search
post('/InternalAPI/ApplicationAPI.asmx/GetCurrencies', {
    Payload: {}
}).then(defaultHandler);
export const getCurrenciesSorted = (sortBy) => post('/InternalAPI/ApplicationAPI.asmx/GetCurrenciesSorted', {
    CurrencySortBy: sortBy
}).then(defaultHandler);
// keyword parameter for textbox search
export const getDepartments = (options = {}) => post('/InternalAPI/DepartmentAPI.asmx/GetDepartments', {
    Emp: options.Emp
}).then(defaultHandler);
export const getDepartmentsByKeyword = (keyword = '', options = {}) => post('/InternalAPI/DepartmentAPI.asmx/GetDepartmentsByKeyword', {
    Keyword: keyword,
    Emp: options.Emp
}).then(defaultHandler);
export const getStateProvinces = () => post('/InternalAPI/ApplicationAPI.asmx/GetStateProvinceList').then(defaultHandler);
// Similar to the above endpoint, but uses the new WebApi instead. The return Dto is slightly different
export const getStatesAndProvinces = async () => {
    const response = await get('/webapi/api/StateProvince');
    webApiResponseHandler(response);
    const data = await response.json();
    return data;
};
export const getUsStates = async () => {
    const response = await get('/webapi/api/StateProvince?usStatesOnly=true');
    webApiResponseHandler(response);
    const data = await response.json();
    return data;
};
export const getCompanyPreference = (Key1, Key2) => post('/InternalAPI/ApplicationAPI.asmx/GetCompanyPreference', { Key1, Key2 }).then(parseData);
export const saveCompanyPreference = (Key1, Key2, Data) => post('/InternalAPI/ApplicationAPI.asmx/SaveCompanyPreference', { Key1, Key2, Data }).then(parseData);
export const deleteCompanyPreference = (Key1, Key2) => post('/InternalAPI/ApplicationAPI.asmx/DeleteCompanyPreference', { Key1, Key2 }).then(parseData);
export const saveUserPreference = (Key1, Data) => post('/InternalAPI/ApplicationAPI.asmx/SaveUserPreference', {
    PreferenceName: Key1,
    Value: Data
}).then(parseData);
export const deleteUserPreference = (Key1) => post('/InternalAPI/ApplicationAPI.asmx/DeleteUserPreference', { PreferenceName: Key1 }).then(parseData);
export const validateReceiptAuthCode = (code) => post('/InternalAPI/ApplicationAPI.asmx/ValidateAttachmentAuthCode', { code }).then(parseData);
export const regenerateReceiptAuthCode = () => post('/InternalAPI/ApplicationAPI.asmx/RegenerateAttachmentAuthCode').then(parseData);
export const setSessionReturnURL = (ReturnURL) => post('/InternalAPI/ApplicationAPI.asmx/SetReturnURL', { ReturnURL }).then(parseData);
export const reloadUDFCache = () => post('/InternalAPI/ApplicationAPI.asmx/ReloadUDFCache').then(parseData);
